import React from "react";
import { Link } from "gatsby";

// CSS
import "./Footer.css";

const Index = ({ footerRef }) => {
  const currentUrl =
    typeof window !== "undefined" ? window.location.pathname : "";
  const isContactPage = currentUrl.includes("contact");
  const socialMediaLinks = [
    {
      link: "https://www.linkedin.com/in/hanzala-/",
      iconClass: "fa-linkedin",
    },
    {
      link: "https://github.com/justhanzala",
      iconClass: "fa-github",
    },
    {
      link: "https://twitter.com/justhanzala",
      iconClass: "fa-twitter",
    },
    {
      link: "https://www.upwork.com/freelancers/hanzala",
      text: "up",
    },
    {
      link: "https://www.youtube.com/channel/UCuotTM8ASzIH8T06p9uZt8Q",
      iconClass: "fa-youtube",
    },
    {
      link: "https://www.facebook.com/profile.php?id=100006154725853",
      iconClass: "fa-facebook-f",
    },
    {
      link: "https://www.instagram.com/me.hanzala/",
      iconClass: "fa-instagram",
    },
    {
      link: "https://justhanzala.medium.com/",
      iconClass: "fa-medium-m",
    },
    {
      link: "https://join.skype.com/invite/xNOYFg7bGhdM",
      iconClass: "fa-skype",
    },
  ];

  return (
    <footer className="footer bg-blue-gradient" ref={footerRef}>
      {!isContactPage && (
        <div className="bg-darkblue container d-flex flex-column flex-md-row justify-content-around align-items-center py-5 mb-5">
          <h2 className="fs-2 text-white text-center fw-bold">
            Let's Build Together
          </h2>

          <p className="col-md-4 text-center my-3 my-md-0 fs-4 text-white">
            Ready to turn your idea into reality? <br /> Schedule a chat with
            me.
          </p>

          <div className="mt-4 mt-md-0">
            <Link
              to="/contact/"
              className="btn-solid-lg rounded fw-bold px-4 py-3 fs-5"
            >
              Start a Conversation
              <i className="fa-solid fa-chevron-right ms-1" />
            </Link>
          </div>
        </div>
      )}

      <div className="container">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="mb-2 text-center">
            <h2 className="text-white fs-2 fw-bold">
              Hanzala - Self-Taught Developer
            </h2>
          </div>

          <div className="mt-3">
            {socialMediaLinks.map(({ link, iconClass, text }, index) => {
              return (
                <span className="fa-stack" key={index}>
                  <a href={link} target="_blank" rel="noreferrer">
                    <i className="fas fa-circle fa-stack-2x"></i>
                    {iconClass ? (
                      <i className={`fab ${iconClass} fa-stack-1x`}></i>
                    ) : (
                      <span className="fa-stack-1x fw-bold">{text}</span>
                    )}
                  </a>
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Index;
